// Order management types: orders, fills, quote suggestions

export type OrderFill = {
  fillId?: string;
  quantity: number;
  price: number;
  time: string;
  cumQty: number;
  leavesQty: number;
  value?: number;
};

// FIX TimeInForce values: 0=Day, 1=GTC, 3=IOC, 4=FOK, 6=GTD/GTT
export const TIF_LABELS: Record<number, string> = {
  0: 'Day',
  1: 'GTC',
  3: 'IOC',
  4: 'FOK',
  6: 'GTD/GTT',
};

export const TIF_OPTIONS = [
  { v: 0, label: 'Day',     desc: 'Cancel at session close (16:00 EAT)' },
  { v: 1, label: 'GTC',     desc: 'Good Till Cancelled — never auto-expires' },
  { v: 3, label: 'IOC',     desc: 'Immediate Or Cancel' },
  { v: 4, label: 'FOK',     desc: 'Fill Or Kill' },
  { v: 6, label: 'GTD/GTT', desc: 'Good Till Date/Time — set expiry below' },
] as const;

export type Order = {
  id: string;
  exchangeOrderId?: string;
  symbol: string;
  side: 'buy' | 'sell';
  qty: number;
  price: number;
  status: 'new' | 'filled' | 'rejected' | 'partially_filled' | 'cancelled';
  time: string;
  fills: OrderFill[];
  cumQty: number;
  leavesQty: number;
  avgFillPrice?: number;
  lastFillTime?: string;
  // FIX TimeInForce fields
  timeInForce?: number;
  expireDate?: string;   // YYYYMMDD
  expireTime?: string;   // HH:MM:SS DSE local
};

export type QuoteAction = 'NEW' | 'UPDATE' | 'CANCEL' | 'HOLD';

export type QuoteDecisionReason =
  | 'QUOTE'
  | 'NO_ORDERBOOK'
  | 'RISK_LIMIT'
  | 'OUTSIDE_HOURS'
  | 'NO_CASH'
  | 'INVENTORY_MAX'
  | 'ILLIQUID_MARKET';

export interface QuoteSuggestion {
  quote_id: string;
  ticker: string;
  symbol?: string;
  secId?: string;
  mode: string;
  bid: { price: number | null; qty: number | null };
  ask: { price: number | null; qty: number | null };
  confidence: number;
  reason: string;
  timestamp: string;
  action?: QuoteAction;
  spread_bps?: number;
  quote_decision?: QuoteDecisionReason;
  features?: {
    fill_probability?: number;
    inventory_skew?: number;
    regime?: string;
    adverse_selection_prob?: number;
    time_to_trade?: number;
    ofi?: number;
    spread_zscore?: number;
    [key: string]: number | string | undefined;
  };
}

export interface QuoteDecisionRequest {
  type: 'QUOTE_DECISION';
  quote_id: string;
  accepted: boolean;
  reason?: string;
}
